import { atom } from "jotai";

export const pasoActualAtom = atom(0);
export const colaboradorAtom = atom(undefined);
export const linkValidoAtom = atom(true);
export const loadingAtom = atom(false);
